import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import { useErrorFile, useAcceptedFile } from "@/utils/utils.js";
import ModalWrapperChildren from '@/views/components/Modal/ModalWrapperChildren';

import Alert from '@/views/components/Alert/Alert';

import api from "@/services/api";

import styles from '@/views/pages/Dictionary/Dictionary.module.scss';

const ModalLoadDictionary = ({ reloadDictionary, showModalLoadDictionary, setShowModalLoadDictionary }) => {
	const { dict } = useSelector(state => state.app);
	const [ requestIsPending, setRequestIsPending ] = useState(false);
	const [ error, setError ] = useState(null);
	const [ myFiles, setMyFiles ] = useState([]);
	
	const { acceptedFiles, fileRejections, getRootProps, getInputProps } = useDropzone({
		accept: {
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [ ".xlsx" ],
		},
		multiple: false,
	});

	const handleClose = () => {
		reloadDictionary();
		setRequestIsPending(false);
		setShowModalLoadDictionary(false);
		setMyFiles([]);
		setError(null);
	};

	const getErrorFile = useErrorFile();
	const getAcceptedFile = useAcceptedFile();
	
	const addFile = () => {
		if (acceptedFiles.length > 0) {
			setRequestIsPending(true);
			const formD = new FormData();
			formD.append("dictFile", acceptedFiles[0]);

			api.post(`/dict-entries/import/excel`, formD, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			}).then(res => {
				if(res.status === 200) {
					if(res.data.length > 0) {
						getErrorRows(res.data);
					} else if (res.data.length === 0 ) {
						handleClose();
					}
				}
				setRequestIsPending(false);
			});
		}
	};
	
	const getErrorRows = (errorRow) => {
		if(errorRow.length === 1 && errorRow[0] === 1) {
			setError(dict.dictionary.modalLoad.errors.headers);
		} else if (errorRow.length > 0) {
			const rows = errorRow.map(row => row).join(', ');
			const text = `${dict.dictionary.modalLoad.errors.rows} ${rows}`;
			setError(text);
		}
	};

	useEffect(() => {
		if(fileRejections.length > 0) {
			const err = fileRejections.map(f => f.errors.map(e => getErrorFile(e.code)));
			setError(err[0]);
		} else {
			setError('');	
		}
		
	}, [ fileRejections ]);
	
	useEffect(() => {
		if(acceptedFiles.length > 0) {
			setMyFiles(getAcceptedFile(acceptedFiles));
		}
	}, [ acceptedFiles ]);

	return (
		<>
			<ModalWrapperChildren 
				onClose={ handleClose }
				setModalVisible={ setShowModalLoadDictionary }
				modalVisible={ showModalLoadDictionary }
				onConfirm={  () => addFile() }
				closeButtonName={ dict.cancel }
				confirmButtonName={ dict.dictionary.modalLoad.confirm }
				requestIsPending={ requestIsPending }
				title={ dict.dictionary.modalLoad.title }
				isLine
			>
				<p 
					className={ styles["load-dictionary--info"] } 
					style={ { paddingTop: '16px' } }
				>
					{dict.dictionary.modalLoad.desc.part1}
				</p>
				<ol className={ styles["load-dictionary--list"] }>
					<li>{dict.dictionary.modalLoad.desc.part2.element1}</li>
					<li>{dict.dictionary.modalLoad.desc.part2.element2}</li>
					<li>{dict.dictionary.modalLoad.desc.part2.element3}</li>
					<li>{dict.dictionary.modalLoad.desc.part2.element4}</li>
					<li>{dict.dictionary.modalLoad.desc.part2.element5}</li>
				</ol>
				<p className={ styles["load-dictionary--info"] }>{dict.dictionary.modalLoad.desc.part3}</p>
				<p className={ styles["load-dictionary--dropzone-header"] }>{dict.dictionary.modalLoad.info}</p>
				{error && (
					<Alert
						variant='error'
						alertContent={ <>
							<strong>
								{dict.dictionary.modalLoad.error.part1}
							</strong>{dict.dictionary.modalLoad.error.part2}
							<ol className={ styles["load-dictionary--error-list"] }>
								<li>{dict.dictionary.modalLoad.error.part3.element1}</li>
								<li>{dict.dictionary.modalLoad.error.part3.element2}</li>
								<li>{dict.dictionary.modalLoad.error.part3.element3}</li>
							</ol>
						</> }
					/>
				)}
				{myFiles.length > 0 && (
					<Alert
						variant='info'
						alertContent={ <>{dict.dictionary.modalLoad.addedFile} <strong>{myFiles[0].key}</strong></> }
					/>
				)}
				{myFiles.length > 0 && (
					<p className={ styles["load-dictionary--dropzone-header"] }>{ dict.dictionary.modalLoad.loadAnotherFile }</p>
				)}
				<section className={ styles["load-dictionary--dropzone"] }>
					<div { ...getRootProps({ className: "addletter__dropzone" }) }>
						<input { ...getInputProps() } />
						<p dangerouslySetInnerHTML={ { __html: dict.addLetter.dragFiles } } />
					</div>
				</section>
				<Alert
					variant='warning'
					alertContent={ <><strong>{dict.dictionary.modalLoad.warning.part1}</strong> { dict.dictionary.modalLoad.warning.part2 }</> }
				/>
			</ModalWrapperChildren>
		</>
	);
};

export default ModalLoadDictionary;
